import React, { useEffect, useState } from 'react';
import client from '../../utils/prismicHelpers';
import * as queries from "../../utils/prismicQueries";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './pdf.css'
import pdf from './../../assets/PDF/Project Vaani - RFP V2 -Argus mark-up.docx (3).pdf'

import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
// import ChartList from './ChartList';
const Rep = () => {
    const [responseInfo, setResourceInfo] = useState(null);
    useEffect(() => {
        client
            .query({
                query: queries.rfp,
            })
            .then((response) => {
                const resourcesDoc = response.data.allReps.edges[0].node;
                setResourceInfo(resourcesDoc);
                window.scrollTo(0, 0);


            })
            .catch((error) => {
                console.error(error);
            });
    });
    const pdfStyle = {
        fontSize: "30px",
        color: "red"
    }

    return (
        <div style={{ backgroundImage: 'url(' + responseInfo?.section_bg?.url + ')' }} className=" rep-section pattern">
            < div className="container  d-flex flex-column  justify-content-center align-items-center" >
                <h5 className="section-title  pb-2" > {responseInfo?.name_title} <strong> {responseInfo?.name_f_line}</strong></h5>
                <h5 className="section-title  pb-2 ps-4 ps-md-0" >  <strong>{responseInfo?.name_s_line}</strong></h5>
                <div className="d-flex align-items-center">
                    <div><FontAwesomeIcon style={pdfStyle} icon={faFilePdf} /></div>
                    <a href={responseInfo?.pdf?.url} target="_blank" className="ms-3 " >Link</a>
                </div>
                <p className="footer-date mt-3">  {responseInfo?.date_text}</p>
                <p className="footer-email"> {responseInfo?.email_text}</p>
            </div>

        </div >
    );
};

export default Rep;

